import React, {useRef} from 'react';
import MobilePopup from '../newPopup/mobilePopup/MobilePopup';
import * as css from './ProcessPopup.css';
import {ProcessPopupProps, ButtonConfig} from './ProcessPopup.types';
import Stepper from './Stepper';
import FooterButtons from './FooterButtons';
import CustomScrollbar from '../customScrollbar/CustomScrollbar';
import useMobile from '../../hooks/useMobile';
import useTimeout from '../../hooks/useTimeout';

function ProcessPopup({show, title, steps = [], currentStep = 0, headerItems = null, children, buttons = [], dataCyName = 'processPopup', height = 'max-content', onStepClick = null, validateStep, closeProps = {}}: ProcessPopupProps) {
    const refContent = useRef(null);
    const isMobile = useMobile();
    const timer = useTimeout();

    const handleStepClick = async (stepIndex: number): Promise<void> => {
        if(onStepClick && stepIndex !== currentStep) {
            if(validateStep && stepIndex > currentStep) {
                const isValid = await validateStep(currentStep);
                if(!isValid) {
                    return;
                }
            }
            onStepClick(stepIndex);
            if(refContent.current) {
                refContent.current.scrollTop = 0;
            }
        }
    };

    const handleButtonClick = (button: ButtonConfig, index: number): void => {
        if(button.onClick) {
            button.onClick(button, index, currentStep);
            timer.current = setTimeout(() => {
                if(refContent.current) {
                    refContent.current.scrollTop = 0;
                }
            }, 0);
        }
    };

    return (
        <MobilePopup 
            showClass={show.showClass}
            close={show.close}
            title={title}
            height={height}
            dataCyName={dataCyName}
            closeProps={closeProps}
            list={false}
            forwardRef={null}
            TopComponent={null}
        >
            {headerItems && <css.headerItems>{headerItems}</css.headerItems>}
            <css.wrap>
                <Stepper
                    steps={steps}
                    currentStep={currentStep}
                    onStepClick={onStepClick ? handleStepClick : undefined}
                    validateStep={validateStep}
                    dataCyName={dataCyName}
                />
                {!isMobile && <CustomScrollbar contentRef={refContent} cssStyle={'z-index: unset;'} maxBottom={65}/>}
                <css.body ref={refContent}>
                    {steps[currentStep]?.comp ?? children}
                </css.body>
                <FooterButtons buttons={buttons} dataCyName={dataCyName} onClick={handleButtonClick} />
            </css.wrap>
        </MobilePopup>
    );
}

export default ProcessPopup;
